import Tabs from "./Tabs";
import DarkMode from "./DarkMode";
import Footer from "./Footer";
import paldea_dex from "../dex.json";

export default function App() {
  let initialData = paldea_dex;
  let savedData = localStorage.getItem("pokedex");
  if (savedData !== null) {
    initialData = JSON.parse(savedData);
  }

  return (
    <div>
      <DarkMode />
      <Tabs initialPokedex={initialData} />
      <Footer />
    </div>
  );
}
